import React from 'react'
import Image from 'next/image'
import { Header1 } from '../../styles/Components'
import HeroImg from '../../../public/how-it-works/GS_how_it_works_hero.jpg'

const Header = () => {
  return (
    <div className="how-it-works-header section-wrapper">
      <Image 
        src={HeroImg}
        alt='how it works'
        style={{ objectFit: 'cover' }}
        fill
        priority
      />
      <Header1 align="center" white>
        GOODBYE BAD HAIR DAYS,
      </Header1>
      <Header1 align="center" white>
        CHIPPED NAILS +
      </Header1>
      <Header1 align="center" white>
        SMOKEY EYE FAILS.
      </Header1>
    </div>
  )
}

export default Header
